import { reactive } from 'vue'
export const cacheStorage = reactive({
  cache: new Map(),
  getCache(key: string) {
    return this.cache.get(key)
  },

  setCache(key: string, data: unknown) {
    return this.cache.set(key, data)
  },
  hasCache(key: string) {
    return this.cache.has(key)
  },
  clearAllCache() {
    this.cache.clear()
  },
  clearSpecificCache(keyPart: string) {
    for (const [key] of this.cache) {
      try {
        const parsedKey = JSON.parse(key)

        if (parsedKey.key === keyPart) {
          this.cache.delete(key)
        }
      } catch (e) {
        //error
      }
    }
  }
})
